// Global navigation guard for intercepting programmatic navigate() calls
type GuardCallback = (targetPath: string) => boolean; // return true to block

let activeGuard: GuardCallback | null = null;

export function setNavigationGuard(guard: GuardCallback | null) {
  activeGuard = guard;
}

export function checkNavigationGuard(targetPath: string): boolean {
  return activeGuard ? activeGuard(targetPath) : false;
}
